import _ from 'lodash';
import { ReactNode, useEffect, useMemo } from 'react';
import { useIntersectionObserver } from 'usehooks-ts';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.scss';
import 'slick-carousel/slick/slick-theme.scss';
import { Box, Image } from '@wix/design-system';
import {
  ACTIONS,
  useTemplateContext,
} from '@components/Contexts/TemplateContext';
import CustomArrowWrapper from '../Carousels/CustomArrowWrapper';
import { ChevronLeft, ChevronRight } from '@wix/wix-ui-icons-common';
import { useTemplateBi } from '@components/Hooks/useTemplateBi';
import s from './FullWidthCarousel.module.scss';
import { getTemplateGradientBackground } from '@utils/templateUtils';

type FullWidthCarouselProps = {
  children?: ReactNode;
};

function FullWidthCarousel({}: FullWidthCarouselProps) {
  const { template } = useTemplateContext();
  const { logBiClick } = useTemplateBi({ is_mobile: false });

  const { dispatch } = useTemplateContext();
  const { isIntersecting, ref } = useIntersectionObserver({});

  useEffect(() => {
    dispatch({ type: ACTIONS.SHOW_STICKY_CTAS, show: !isIntersecting });
  }, [isIntersecting]);

  const gradientBackground = useMemo(() => getTemplateGradientBackground(), []);

  const settings = {
    className: s.heroCarouselNavSlider,
    autoplay: true,
    centerMode: true,
    variableWidth: true,
    infinite: true,
    slidesToShow: 1,
    speed: 2000,
    autoplaySpeed: 5000,
    pauseOnHover: true,
    nextArrow: (
      <CustomArrowWrapper>
        <ChevronRight
          color="#ffffff"
          onClick={() => {
            logBiClick({ clickType: 'next picture - from Image' });
          }}
        />
      </CustomArrowWrapper>
    ),
    prevArrow: (
      <CustomArrowWrapper>
        <ChevronLeft
          color="#ffffff"
          onClick={() => {
            logBiClick({ clickType: 'previous picture - from Image' });
          }}
        />
      </CustomArrowWrapper>
    ),
  };
  return (
    <div
      ref={ref}
      style={{
        overflow: 'hidden',
        background: gradientBackground,
      }}
      className={s.sliderContainer}
    >
      <Slider {...settings}>
        {_.map(template.media?.additionalImages, (slide, id) => (
          <Box width={'100%'} height={'100%'}>
            <div
              style={{
                backgroundColor: '',
                height: '374px',
                width: '600px',
              }}
            >
              <Box
                width={'100%'}
                height={'100%'}
                align="center"
                verticalAlign="middle"
              >
                <Image
                  alt={slide.description || undefined}
                  src={slide.url}
                  height={'374px'}
                  width={'600px'}
                  borderRadius="4px"
                />
              </Box>
            </div>
          </Box>
        ))}
      </Slider>
    </div>
  );
}

export default FullWidthCarousel;
